export enum ProductType {
  DIGITAL = 'digital',
  EVENT = 'event',
}
